import FileUploadComponent from "../../../components/file/file-upload.component";
import { messageComponent } from "../../../components/message/message.component";
import masterConfigurationModel from "../../../models/config-master.model";
import loginModel from "../../../models/login.model";
import ViewBase from "../../view-base.view";

export default function MasterConfigUploadView() {
  ViewBase.call(this);

  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let location = "";

  let _attachment = { file: undefined, filename: '', fileID: '' };
  let inputFilter = {
    photo: {},
    photoForm: null,
    photoGuid: '00000000-0000-0000-0000-000000000000',
    countryCode: "",
    recordType: "",
    recordCount: "",

  };
  let closeModal = () => { }
  let onUploadCompleted = () => { }

  const uploadExcelTemplate = (e) => {
    const promises = [];
    const locations = location ? location.split(',') : [""];
    let DOWNLOAD_YN = false;
    if (locations.length > 0) {
      for (let i = 0; i < locations.length; i++) {
        if (i+1 == locations.length) {
          DOWNLOAD_YN = true;
        }
        promises.push(new Promise((resolve, reject) => {
          masterConfigurationModel.uploadMasterConfiguration(
            (result) => {
              resolve(result);
            },
            (error) => {
              reject(error);
            },
            inputFilter.recordType,
            inputFilter.countryCode,
            inputFilter.recordCount,
            inputFilter.photoForm,
            locations[i],
            DOWNLOAD_YN
          );
        }));
      }
    }

    Promise.all(promises)
      .then(result => {
        onUploadCompleted();
      }).catch(error => {
        // console.error('Error:', error)
        isMsgOpen = true;
        showMsg = this.getText("EM00000138", "Server error. Please contact administrator.");
        msgTitle = this.getText("EM00000142", "Error");
      });
  }

  return {
    oninit: (vnode) => {
      if (typeof vnode.attrs.closeModal === 'function') {
        closeModal = vnode.attrs.closeModal;
      }
      if (vnode.attrs.onUploadCompleted) {
        onUploadCompleted = vnode.attrs.onUploadCompleted;
      }
      if (vnode.attrs.recordType) {
        inputFilter.recordType = vnode.attrs.recordType;
      }
      inputFilter.countryCode = loginModel.credentials.country;
      // if (vnode.attrs.countryCode) {
      //   inputFilter.countryCode = vnode.attrs.countryCode;
      // }
      if (vnode.attrs.recordCount) {
        inputFilter.recordCount = vnode.attrs.recordCount;
      }
      location = vnode.attrs.location;
    },
    view: (vnode) => {
      return [
        m('.container',
          m('.row.g-3',
            m('.col-12',
              m('label.form-label', this.getText("LT00000515", "Upload Excel")),
              m(FileUploadComponent, {
                acceptableFileTypes: ['.xlsx'], isOnlySingleFileUpload: true,
                onGettingFiles: (file) => {
                  if (file.length > 0) {
                    _attachment.file = file[0];
                    _attachment.filename = file[0].name;
                    inputFilter.photoGuid = file[0].name;
                    inputFilter.photo = _attachment;
                    inputFilter.photoForm = new FormData();
                    inputFilter.photoForm.append("file", file[0]);
                  }
                  else {
                    isMsgOpen = true;
                    showMsg = this.getText("EM00000082", "Invalid file. Cannot process.");
                    msgTitle = this.getText("EM00000142", "Error");
                  }
                }
              })
            ),
            m('.d-flex.gap-2.justify-content-end.mt-4',
              m('button.btn.btn-primary[type=button]', { onclick: uploadExcelTemplate },
                this.getText("LT00000290", "Upload")
              ),
              m('button.btn.btn-white[type=button]', {
                onclick:closeModal
              },
                this.getText("LT00000021", "Close")
              ),
            )
          ),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => { isMsgOpen = false; } })
        ),
        this.getBaseViews()
      ]
    }
  }
}